import { ValidationError } from "./validationError";
import { FormDataKey } from "src/types";

export class ValidationErrors<T extends FormDataKey> extends Array<ValidationError<T>> {
  getErrorMessageByFormDataKey(formDataKey: T): string {
    return this.filter((validationError) => validationError.formDataKey === formDataKey)
      .map((validationError) => validationError.message)
      .join(", ");
  }

  clearValidationError(formDataKey: T): ValidationErrors<T> {
    return new ValidationErrors(...this.filter((validationError) => !(validationError.formDataKey === formDataKey)));
  }
}
